import ApplicationSerializer, { hasAttributes } from 'teacher-ui-client/serializers/application'

export default class TeacherSerializer extends ApplicationSerializer {
  /**
   * language is a virtual backend attribute, so it is not required when creating/updating a teacher.
   */
  attrs = {
    language: { serialize: false },
  }

  serialize(...args: Parameters<ApplicationSerializer['serialize']>) {
    const [snapshot] = args
    const json = super.serialize(...args)

    if (hasAttributes(json)) {
      // additional options that might be provided with a teacher.save() call
      const { passwordCurrent, password, passwordConfirmation, accountType, subscriptionType } =
        snapshot.adapterOptions ?? {}
      // passwordCurrent only given if editing own password.
      if (password && passwordConfirmation) {
        if (passwordCurrent) json.data.attributes['password-current'] = passwordCurrent
        json.data.attributes.password = password
        json.data.attributes['password-confirmation'] = passwordConfirmation
      }
      if (accountType) json.data.attributes['account-type'] = accountType
      if (subscriptionType) json.data.attributes['subscription-type'] = subscriptionType
    }

    return json
  }
}
